// src/EmojiButton.js
import React, { useState } from 'react';
import uniqid from 'uniqid';
import './styles.scss';
import { updateData } from '../../assets/js/functions';

const EmojiButton = ({ idMensaje }) => {
	const [showEmojis, setShowEmojis] = useState(false);

	const emojis = ['😀', '❤️', '😨', ' 👍', '👏'];

	const toggleEmojis = () => {
		setShowEmojis(!showEmojis);
	};

	const setReacciones = (index, id) => {
		const identificador = uniqid();
		updateData(`reacciones/${id}`, identificador, { reaccion: index }).then(() => {
			setShowEmojis(false);
		});
	};

	return (
		<div id='emojis'>
			<button onClick={toggleEmojis}>{showEmojis ? '❌' : '😀'}</button>
			{showEmojis && (
				<div style={{ marginTop: '10px', fontSize: '24px' }}>
					{emojis.map((emoji, index) => (
						<span className='cursor' key={index} style={{ margin: '5px' }} onClick={() => setReacciones(index, idMensaje)}>
							{emoji}
						</span>
					))}
				</div>
			)}
		</div>
	);
};

export default EmojiButton;
